import { getPatternStyles, patternFns, __spreadValues, __objRest } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const levelConfig = {
transform(props) {
  const _a = props, { align, pinCenter } = _a, rest = __objRest(_a, ["align", "pinCenter"]);
  if (pinCenter) {
    return __spreadValues({
      display: "grid",
      gridTemplateColumns: "1fr auto 1fr",
      gridTemplateAreas: "'left center right'",
      columnGap: "2rem"
    }, rest);
  }
  return __spreadValues({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: align
  }, rest);
}}

export const getLevelStyle = (styles = {}) => {
  const _styles = getPatternStyles(levelConfig, styles)
  return levelConfig.transform(_styles, patternFns)
}

export const level = (styles) => css(getLevelStyle(styles))
level.raw = getLevelStyle